import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BufferService, LoadingContext, M_Button, M_Header, NavigateContext } from 'src/M_Components'
import { EblPartyNameInfo } from './components/EblPartyNameInfo'

export const EblPartyNameDetail = ({ roles }) => {
    const ctx = useContext(LoadingContext)
    const navigateCtx = useContext(NavigateContext)
    const { t } = useTranslation()

    const eblPartyNameService = new BufferService('eblPartyName')

    const [data, setData] = useState({})
    const [isFirstTime, setIsFirstTime] = useState(true)
    const [tabId, setTabId] = useState(sessionStorage.getItem('selectedTab'))
    const [operation, setOperation] = useState()

    const sessionKeys = ['operation', 'data', 'open', 'passedRow']

    useEffect(() => {
        setOperation(ctx.passValue.get('operation'))

        if (isFirstTime) {
            ctx.setIsLoad(true)
            getSessionStorageData(tabId)
            setIsFirstTime(false)
            sessionStorage.setItem(`tab${tabId}`, JSON.stringify(sessionKeys))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== tabId) {
            setTabId(newId)
            getSessionStorageData(newId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
        const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`))

        if ((tempO && tempO !== '') || (tempD && Object.keys(tempD).length !== 0)) {
            setData(tempD || {})
            setOperation(tempO)
            ctx.setIsLoad(false)
            return
        }

        get()
    }

    const get = () => {
        if (ctx.passValue.get('operation') === 'create') {
            ctx.setIsLoad(false)
            return
        }

        eblPartyNameService
            .getId(ctx.passValue.get('row').Id)
            .then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.toastMessages('error', t('Error'), response?.response?.data?.Errors || response.message)
                    ctx.setIsLoad(false)
                    return
                }
                setData(response)
                ctx.setIsLoad(false)
            })
            .catch((err) => {
                ctx.toastMessages('error', err.message, 'Error')
                ctx.setIsLoad(false)
            })
    }

    const save = () => {
        if (!data.InternalName || !data.EblName || !data.PartyRole) {
            ctx.toastMessages('error', t('Error'), t('Please fill all required fields.'))
            return
        }

        ctx.setIsLoad(true)

        if (operation === 'create') {
            eblPartyNameService.post(data).then((response) => {
                if (response.name === 'AxiosError') {
                    const errData = response?.response?.data
                    ctx.toastMessages(
                        'error',
                        t('ErrorCreating'),
                        errData != null ? Object.values(errData).flat().join('\n') || response.message : response.message
                    )
                    ctx.setIsLoad(false)
                } else {
                    ctx.toastMessages('success', t('Success'), t('Created successfully'))
                    ctx.setIsLoad(false)
                    navigateCtx.closeTab(tabId.replace(/"/g, ''))
                }
            })
        } else if (operation === 'edit') {
            eblPartyNameService.update(data.Id, data).then((response) => {
                if (response.name === 'AxiosError') {
                    const errData = response?.response?.data
                    ctx.toastMessages(
                        'error',
                        t('ErrorUpdating'),
                        errData != null ? Object.values(errData).flat().join('\n') || response.message : response.message
                    )
                    ctx.setIsLoad(false)
                } else {
                    ctx.toastMessages('success', t('Success'), t('Edited successfully'))
                    ctx.setIsLoad(false)
                    navigateCtx.closeTab(tabId.replace(/"/g, ''))
                }
            })
        }
    }

    return (
        <div>
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t('Save')}
                            label={t('Save')}
                            icon={
                                <img
                                    src="/icons/svgsDaNet/download.svg"
                                    style={{
                                        filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)',
                                        width: '20px'
                                    }}
                                    className="downloadPdf"
                                    alt="Save"
                                />
                            }
                            onClick={() => save()}
                        />
                    </>
                }
            />
            <EblPartyNameInfo dataState={data} setDataState={setData} />
        </div>
    )
}
